import * as React from "react";

import { CallOffsContext } from "../providers/CallOffsProvider";

const useCallOffs = () => {
  const { callOffs, isLoading: loadingCallOffs } = React.useContext(CallOffsContext);

  const getProductCallOff = React.useCallback((productId: number) => {
    return callOffs.find(co => co.productId === productId);
  }, [ callOffs ]);

  return {
    callOffs,
    loadingCallOffs,
    getProductCallOff
  };
};

export default useCallOffs;
